<template>
    <div class="ayuda-container" data-app>
        <section class="doc-section ayuda-scope">
            <div class="container-fluid px-0">

                <div class="mb-6">
                    <BotonesNavegacion @cambio-plataforma="plataformaActual = $event" />
                </div>

                <div class="section-container mb-5">
                    <div class="section-title-bar mb-4">
                        <h2>Grupos</h2>
                    </div>
                    <p class="section-desc">
                        Para visualizar la lista de grupos creados en el sistema, ir al menú y hacer
                        clic sobre la opción <strong>Grupo</strong>.
                    </p>
                    
                    <div class="two-col">
                        <div class="col-image">
                            <div class="carrusel-wrapper-box p-2">
                                <CarruselAciqui :items="carruselListado" />
                            </div>
                        </div>

                        <div class="col-steps">
                            <p class="steps-label">Referencias del listado</p>

                            <div class="step-card">
                                <div class="step-badge">1</div>
                                <div>
                                    <div class="step-desc">Campo <strong>buscar</strong>, permite filtrar los elementos de la tabla de forma dinámica.</div>
                                </div>
                            </div>

                            <div class="step-card">
                                <div class="step-badge">2</div>
                                <div>
                                    <div class="step-desc">Botón <strong>agregar grupo</strong>, permite ir a la vista para registrar un nuevo grupo.</div>
                                </div>
                            </div>

                            <div class="step-card">
                                <div class="step-badge">3</div>
                                <div>
                                    <div class="step-desc">Tabla con los <strong>grupos registrados</strong>, muestra el nombre y las acciones de estado/edición.</div>
                                </div>
                            </div>

                            <div class="step-card">
                                <div class="step-badge">4</div>
                                <div>
                                    <div class="step-desc"><strong>Paginación</strong>: permite navegar entre los diferentes registros del sistema.</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="doc-note note-warning mt-4">
                        <svg class="note-icon" width="15" height="15" viewBox="0 0 16 16" fill="none">
                            <path d="M8 2L14.9 14H1.1L8 2Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                            <circle cx="8" cy="11.5" r="0.75" fill="currentColor"/>
                        </svg>
                        <div class="note-body">
                            <span class="note-label">Nota</span>
                            <p>Solo el <strong>usuario master</strong> podrá visualizar esta vista.</p>
                        </div>
                    </div>
                </div>

                <hr class="section-divider my-5" />

                <div class="section-container mb-5">
                    <div class="section-title-bar mb-4">
                        <h2>Realizar Búsqueda</h2>
                    </div>
                    <p class="section-desc">
                        En la vista de grupos se visualizan todos los grupos registrados, así como un campo
                        "Buscar" que permite filtrar datos en la tabla.
                    </p>
                    <div class="two-col alternate-flow">
                        <div class="col-steps">
                            <div class="card-detallada p-4">
                                <ol class="lista-instrucciones">
                                    <li>Ingresar la palabra o <strong>palabras clave</strong> para realizar el filtrado.</li>
                                    <li>El sistema mostrará en la tabla el resultado de la búsqueda como se muestra en la imagen siguiente.</li>
                                </ol>
                            </div>
                        </div>
                        <div class="col-image">
                            <div class="carrusel-wrapper-box p-2">
                                <CarruselAciqui :items="carruselBusqueda" />
                            </div>
                        </div>
                    </div>
                </div>

                <hr class="section-divider my-5" />

                <div class="section-container mb-5">
                    <div class="section-title-bar mb-4">
                        <h2>Agregar y Editar Grupo</h2>
                    </div>
                    <div class="carrusel-wrapper-box p-3">
                        <CarruselAciqui :items="carruselAgregarEditar" />
                    </div>
                </div>

                <div class="success-section">
                    <p class="success-text">
                        Al guardar los cambios exitosamente, el sistema mostrará la siguiente notificación:
                    </p>

                    <div class="carrusel-wrapper-box success-carousel p-2">
                        <CarruselAciqui :items="carruselExitoAgregarEditar" />
                    </div>
                </div>

                <hr class="section-divider my-5" />

                <div class="section-container mb-5">
                    <div class="section-title-bar mb-4">
                        <h2>Deshabilitar y Habilitar Grupo</h2>
                    </div>
                    <p class="section-desc">
                        Desde la tabla de grupos, usa el switch para cambiar el estado del registro.
                    </p>
                    <div class="row mx-0">
                        <div class="col-12 col-md-6 px-0 pr-md-3 mb-4 mb-md-0">
                            <div class="action-flow-card p-4">
                                <div class="flow-header mb-3">
                                    <span class="flow-dot danger"></span>
                                    <h3 class="flow-title">Deshabilitar Grupo</h3>
                                    <span class="switch-track off ml-auto"><span class="switch-thumb"></span></span>
                                </div>
                                <CarruselAciqui :items="carruselDeshabilitar" />
                            </div>
                        </div>
                        <div class="col-12 col-md-6 px-0 pl-md-3">
                            <div class="action-flow-card p-4">
                                <div class="flow-header mb-3">
                                    <span class="flow-dot success"></span>
                                    <h3 class="flow-title">Habilitar Grupo</h3>
                                    <span class="switch-track on ml-auto"><span class="switch-thumb"></span></span>
                                </div>
                                <CarruselAciqui :items="carruselHabilitar" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="success-section">
                    <p class="success-text">
                        Al guardar los cambios exitosamente, el sistema mostrará la siguiente notificación:
                    </p>

                    <div class="carrusel-wrapper-box success-carousel p-2">
                        <CarruselAciqui :items="exitoDeshabilitarHabilitar" />
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
import CarruselAciqui from './Carruselimg.vue';
import BotonesNavegacion from './BotonesNavegacion.vue';

export default {
    name: 'GruposDoc',
    components: { CarruselAciqui, BotonesNavegacion },
    data() {
        return {
            plataformaActual: 'web',

            webData: {
                listado: [
                    {
                        nombre: "Listado",
                        url: 'img/grupos/Listado_Grupos.png',
                        descripcion: "Vista general de grupos."
                    }
                ],

                busqueda: [
                    {
                        nombre: "Búsqueda",
                        url: 'img/grupos/Filtrar_Grupos.png',
                        descripcion: "Filtrado de datos."
                    }
                ],

                agregarEditar: [
                    {
                        nombre: "Agregar Grupo",
                        url: "img/grupos/Formulario_Agregar_Grupo.png",
                        descripcion: "Vista emergente que permite registrar un grupo. Ingresar el nombre del grupo que se desea registrar, presionar el botón Guardar grupo. Presionar el botón Cancelar para cerrar la ventana emergente."
                    },
                    {
                        nombre: "Editar Grupo",
                        url: "img/grupos/Formulario_Editar_Grupo.png",
                        descripcion: "En la tabla de grupos, hacer clic sobre el botón de editar representado con el icono   mostrará la vista de editar grupo. Permite modificar el nombre del grupo, presionar el botón Guardar grupo para almacenar los cambios o presionar el botón Cancelar para descartar los cambios."
                    }
                ],

                exitoAgregarEditar: [
                    {
                        nombre: "Grupo agregado",
                        url: "img/grupos/Mensaje_Exito_Registrar_Grupo.png",
                        descripcion: "Al guardar el grupo exitosamente se mostrará una notificación en la parte superior derecha de sistema como la siguiente."
                    },
                    {
                        nombre: "Grupo editado",
                        url: "img/grupos/Mensaje_Exito_Editar_Grupo.png",
                        descripcion: "Al guardar el grupo exitosamente se mostrará una notificación en la parte superior derecha de sistema como la siguiente."
                    }
                ],

                deshabilitar: [
                    {
                        nombre: "Confirmación",
                        url: "img/grupos/Confirmacion_Deshabilitar_Grupo.png",
                        descripcion: "En la tabla de grupos, hacer clic sobre el switch de deshabilitar representado con el icono switch mostrará una ventana emergente con el mensaje ¿Está seguro que desea deshabilitar el grupo?, hacer clic en el botón “Aceptar” para deshabilitar el grupo o en “Cancelar” para mantener el grupo habilitado. "
                    }
                ],

                habilitar: [
                    {
                        nombre: "Confirmación",
                        url: "img/grupos/Confirmar_Habilitar_Grupo.png",
                        descripcion: "En la tabla de grupos, hacer clic sobre el switch de habilitar representado con el icono switch mostrará una ventana emergente con el mensaje ¿Está seguro que desea habilitar el grupo?, hacer clic en el botón “Aceptar” para habilitar el grupo o en “Cancelar” para mantener el grupo deshabilitado."
                    }
                ],

                exitoDeshabilitarHabilitar: [
                    {
                        nombre: "Grupo deshabilitado",
                        url: "img/grupos/Mensaje_Exito_Deshabilitar_Grupo.png",
                        descripcion: "Al deshabilitar el grupo exitosamente se mostrará una notificación en la parte superior derecha de sistema como la siguiente."
                    },
                    {
                        nombre: "Grupo habilitado",
                        url: "img/grupos/Mensaje_Exito_Grupo_Habilitado.png",
                        descripcion: "Al habilitar el grupo exitosamente se mostrará una notificación en la parte superior derecha de sistema como la siguiente."
                    }
                ],
            },

            mobileData: {
                listado: [
                    {
                        nombre: "Listado",
                        url: 'img/grupos/Listado_Grupos_Movil.png',
                        descripcion: "Vista general de grupos."
                    }
                ],

                busqueda: [
                    {
                        nombre: "Búsqueda",
                        url: 'img/grupos/Filtrar_Grupos_Movil.png',
                        descripcion: "Filtrado de datos."
                    }
                ],

                agregarEditar: [
                    {
                        nombre: "Agregar Grupo",
                        url: "img/grupos/Formulario_Agregar_Grupo_Movil.png",
                        descripcion: "Vista emergente que permite registrar un grupo. Ingresar el nombre del grupo que se desea registrar, presionar el botón Guardar grupo. Presionar el botón Cancelar para cerrar la ventana emergente."
                    },
                    {
                        nombre: "Editar Grupo",
                        url: "img/grupos/Formulario_Editar_Grupo_Movil.png",
                        descripcion: "En la tabla de grupos, hacer clic sobre el botón de editar representado con el icono   mostrará la vista de editar grupo. Permite modificar el nombre del grupo, presionar el botón Guardar grupo para almacenar los cambios o presionar el botón Cancelar para descartar los cambios."
                    }
                ],

                exitoAgregarEditar: [
                    {
                        nombre: "Grupo agregado",
                        url: "img/grupos/Mensaje_Exito_Registrar_Grupo.png",
                        descripcion: "Al guardar el grupo exitosamente se mostrará una notificación en la parte superior derecha de sistema como la siguiente."
                    },
                    {
                        nombre: "Grupo editado",
                        url: "img/grupos/Mensaje_Exito_Editar_Grupo.png",
                        descripcion: "Al guardar el grupo exitosamente se mostrará una notificación en la parte superior derecha de sistema como la siguiente."
                    }
                ],

                deshabilitar: [
                    {
                        nombre: "Confirmación",
                        url: "img/grupos/Confirmacion_Deshabilitar_Grupo_Movil.png",
                        descripcion: "En la tabla de grupos, hacer clic sobre el switch de deshabilitar representado con el icono switch mostrará una ventana emergente con el mensaje ¿Está seguro que desea deshabilitar el grupo?, hacer clic en el botón “Aceptar” para deshabilitar el grupo o en “Cancelar” para mantener el grupo habilitado. "
                    }
                ],

                habilitar: [
                    {
                        nombre: "Confirmación",
                        url: "img/grupos/Confirmar_Habilitar_Grupo_Movil.png",
                        descripcion: "En la tabla de grupos, hacer clic sobre el switch de habilitar representado con el icono switch mostrará una ventana emergente con el mensaje ¿Está seguro que desea habilitar el grupo?, hacer clic en el botón “Aceptar” para habilitar el grupo o en “Cancelar” para mantener el grupo deshabilitado."
                    }
                ],

                exitoDeshabilitarHabilitar: [
                    {
                        nombre: "Grupo deshabilitado",
                        url: "img/grupos/Mensaje_Exito_Deshabilitar_Grupo.png",
                        descripcion: "Al deshabilitar el grupo exitosamente se mostrará una notificación en la parte superior derecha de sistema como la siguiente."
                    },
                    {
                        nombre: "Grupo habilitado",
                        url: "img/grupos/Mensaje_Exito_Grupo_Habilitado.png",
                        descripcion: "Al habilitar el grupo exitosamente se mostrará una notificación en la parte superior derecha de sistema como la siguiente."
                    }
                ],
            }
        }
    },

    computed: {
    carruselListado() {
        return this.plataformaActual === 'web'
            ? this.webData.listado
            : this.mobileData.listado
    },

    carruselBusqueda() {
        return this.plataformaActual === 'web'
            ? this.webData.busqueda
            : this.mobileData.busqueda
    },

    carruselAgregarEditar() {
        return this.plataformaActual === 'web'
            ? this.webData.agregarEditar
            : this.mobileData.agregarEditar
    },

    carruselDeshabilitar() {
        return this.plataformaActual === 'web'
            ? this.webData.deshabilitar
            : this.mobileData.deshabilitar
    },

    carruselHabilitar() {
        return this.plataformaActual === 'web'
            ? this.webData.habilitar
            : this.mobileData.habilitar
    },

    carruselExitoAgregarEditar() {
        return this.plataformaActual === 'web'
            ? this.webData.exitoAgregarEditar
            : this.mobileData.exitoAgregarEditar
    },

    exitoDeshabilitarHabilitar() {
        return this.plataformaActual === 'web'
            ? this.webData.exitoDeshabilitarHabilitar
            : this.mobileData.exitoDeshabilitarHabilitar
    },
}
}
</script>

<style scoped>
.mb-6 {
    margin-bottom: 2rem;
}

/* ── Éxito Estilo ───────────────────────────── */
.success-section {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid var(--border-color);
    text-align: center;
}

.success-section p {
    font-size: 14px;
    opacity: 0.75;
    margin-bottom: 12px;
}

.success-carousel {
    max-width: 720px;
    margin: 0 auto;
}

/* Ajuste visual interno del carrusel */
.success-carousel :deep(.carousel-container) {
    min-height: auto;
}

/* Imagen más compacta como en Geocercas */
.success-carousel :deep(img) {
    width: 100%;
    max-height: 320px;
    object-fit: contain;
    display: block;
    margin: 0 auto;
}

/* ── Layout ──────────────────────────────────────── */
.two-col { display: flex; gap: 30px; align-items: flex-start; }
.col-steps { flex: 1; }
.col-image { flex: 1.4; }

/* ── Títulos Azules ──────────────────────────────── */
.section-title-bar h2 { font-size: 20px; font-weight: 700; color: var(--primary-color); margin: 0; }
.steps-label { font-size: 11px; font-weight: 700; text-transform: uppercase; color: var(--primary-color); letter-spacing: 1px; margin-bottom: 15px; }

/* ── Step Cards ──────────────────────────────────── */
.step-card {
    display: flex; gap: 15px; align-items: center;
    background: var(--code-bg); border: 1px solid var(--border-color);
    border-radius: 10px; padding: 12px 15px; margin-bottom: 10px;
}
.step-badge {
    min-width: 26px; height: 26px; border-radius: 50%;
    background: var(--primary-color); color: #fff;
    font-size: 12px; font-weight: 700;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.step-desc { font-size: 13.5px; line-height: 1.5; color: var(--text-color); }

/* ── Carrusel Box ────────────────────────────────── */
.carrusel-wrapper-box { background: var(--code-bg); border-radius: 10px; border: 1px solid var(--border-color); }

/* ── Otros Estilos Originales ────────────────────── */
.section-desc { font-size: 14.5px; color: var(--text-color); opacity: 0.85; margin-bottom: 24px; line-height: 1.6; }
.section-divider { border: 0; height: 1px; background: var(--border-color); }
.card-detallada { background: var(--code-bg); border: 1px solid var(--border-color); border-radius: 10px; }
.lista-instrucciones { padding-left: 18px; margin: 0; }
.lista-instrucciones li { font-size: 14px; line-height: 1.7; color: var(--text-color); margin-bottom: 8px; }

/* ── Acciones y Switch ───────────────────────────── */
.action-flow-card { background: var(--code-bg); border: 1px solid var(--border-color); border-radius: 10px; height: 100%; }
.flow-header { display: flex; align-items: center; gap: 8px; }
.flow-dot { width: 10px; height: 10px; border-radius: 50%; }
.flow-dot.danger { background: #e53e3e; }
.flow-dot.success { background: #38a169; }
.flow-title { font-size: 14px; font-weight: 700; color: var(--primary-color); margin: 0; }
.ml-auto { margin-left: auto; }

.switch-track { width: 32px; height: 18px; border-radius: 9px; padding: 2px; display: flex; align-items: center; }
.switch-track.off { background: #cbd5e0; }
.switch-track.on { background: #38a169; }
.switch-thumb { width: 14px; height: 14px; background: #fff; border-radius: 50%; }

/* ── Notas ────────────────────────────────────────── */
.doc-note { display: flex; gap: 10px; align-items: flex-start; padding: 13px 16px; border-radius: 6px; border: 1px solid; font-size: 14px; }
.note-warning { background: #fffbeb; border-color: #d97706; color: #d97706; }
.note-label { font-size: 10.5px; font-weight: 700; text-transform: uppercase; }

@media (max-width: 991px) {
    .two-col { flex-direction: column; }
    .alternate-flow { flex-direction: column-reverse; }
}
</style>